import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { find as _find, isEmpty as _isEmpty, includes as _includes, some as _some } from 'lodash-es';
import { marketingAdsChannels } from 'utilities/utilities_exports';

const LandingPageRedirect = () => {
  const navigate = useNavigate();
  const accountDetails = useSelector(state => state.User?.accountDetails);
  const stores = useSelector(state => state?.Account?.stores);
  const { userMenu } = useSelector(state => state.Navigation);
  const { userData } = useSelector(state => state.User);

  // console.log('inside landing page redirect comp..............')

  //TODO: cases need to need
  /**
   * 1. if user has default landing page selected
   * 2. if user has selected landing page from execute
   * 3. if user has not selected landing page and connected any ads channel then land on marketing-deep-dive
   * 4. US and IN customer
   * 5. if user has not selected landing page and access to workspace
   * 6. fallback always home page
   */

  const checkAdsChannelsConnected = useCallback(() => {
    if (!_isEmpty(stores.list)) {
      const isChannelConnected = _some(stores?.list, item => {
        const channelName = item?.split('-')[0];
        return _includes(marketingAdsChannels, channelName);
      });
      return isChannelConnected;
    }
    return false;
  }, [stores?.list]);

  // console.log('comming to landingpageredirect............')

  useEffect(() => {
    const getMenuObj = (userMenu, id) => _find(userMenu, menuObj => menuObj?.id === id) || {};
    if(_isEmpty(userData)) {
navigate('/login')
    } else
    if (!_isEmpty(userData) && userData?.userName?.includes('[admin]')) {
      navigate('/home');
    } else if (!_isEmpty(userMenu)) {
      let landingPageID = accountDetails?.userDetails?.defaultLandingPageID || '';
      let landingPath = '/home';

      const landingPageObj = getMenuObj(userMenu, landingPageID);
      const navAnalyzeObj = getMenuObj(userMenu, 'nav_analyze');
      const navConnectObj = getMenuObj(userMenu, 'nav_connect');

      if (_isEmpty(stores?.list) && _isEmpty(accountDetails?.selectedIntegrations) && !_isEmpty(navConnectObj)) {
        landingPath = '/connect';
      } else if (!_isEmpty(stores)) {
        //! selected landing page not available
        if (!landingPageObj?.isEnabled && navAnalyzeObj?.isEnabled) {
          landingPath = '/home';
        } else if (!landingPageObj?.isEnabled && !navAnalyzeObj?.isEnabled) {
          const firstEnabledMenu = _find(userMenu, menu => menu?.isEnabled) || {};
          landingPath = firstEnabledMenu?.basePath || firstEnabledMenu?.path || '/home';
        }
        //! user selected landing page case
        else if (!_isEmpty(landingPageID) && landingPageObj?.isEnabled) {
          landingPath = landingPageObj?.basePath || landingPageObj?.path || '/home';
        }
        //! no channel connected
      } else if (_isEmpty(stores)) {
        if (navConnectObj?.isEnabled) {
          landingPath = navConnectObj?.basePath || navConnectObj?.path || '/home';
        }
      }
      //! IN, US customers case
      else if (!_isEmpty(accountDetails?.countryCode) && _includes(['IN', 'US'], accountDetails?.countryCode)) {
        const marketingDeepDiveEnabled =
          checkAdsChannelsConnected(marketingAdsChannels) &&
          getMenuObj(userMenu, 'nav_analyze_marketing_deepdive')?.isEnabled;

        if (!_isEmpty(landingPageID) && !_isEmpty(landingPageObj?.isEnabled)) {
          landingPath = landingPageObj?.basePath ?? landingPageObj?.path ?? '/home';
        } else if (marketingDeepDiveEnabled) {
          landingPath = '/analyze/marketing-deep-dive';
        } else if (getMenuObj(userMenu, 'nav_analyze_business')?.isEnabled) {
          landingPath = '/analyze/workspace';
        }
      }

      if (landingPath?.includes('execute/#')) {
        if (landingPageObj?.isEnabled) {
          window.location.href = landingPath;
        } else if (navAnalyzeObj?.isEnabled) {
          landingPath = navAnalyzeObj?.basePath ?? navAnalyzeObj?.path ?? '/home';
        } else {
          landingPath = '/home';
        }
      } else {
        navigate(landingPath || '/home');
      }
    }
  }, [checkAdsChannelsConnected, accountDetails?.countryCode, navigate, accountDetails?.selectedIntegrations, stores, userData?.userName, accountDetails?.userDetails?.defaultLandingPageID, userMenu]);

  return null;
};

export default LandingPageRedirect;
